import {Spinner, Text} from '@chakra-ui/react'

export const ProcessingSection = () => {
	return (
		<>
			<Text mt={4}>Processing...</Text>
			<Spinner />
		</>
	)
}